import React from 'react';
import T, { t } from '../../../../../../common/components/T';
import classNames from 'classnames';
import { API_SERVER_URL } from '../../../../../../common/utils/utils';

export const getFormUserData = (userData, setFormsData, isOfficeRegister) => {
    const fields = isOfficeRegister
        ? [
              {
                  attribute: 'recipient_second_name',
                  group: 'info',
                  subgroup: 'first',
                  required: true,
                  hint: null,
                  options: [],
                  title: {
                      body: <T textName='storeFamily' defaultStr='Фамилия' page='/store' />
                  },
                  type: 'input',
                  value: userData?.last_name
              },
              {
                  attribute: 'recipient_name',
                  group: 'info',
                  subgroup: 'first',
                  required: true,
                  hint: null,
                  options: [],
                  title: {
                      body: <T textName='storeName' defaultStr='Имя' page='/store' />
                  },
                  type: 'input',
                  maxLength: 10,
                  value: userData?.first_name
              },
              {
                  attribute: 'recipient_email',
                  group: 'info',
                  subgroup: 'first',
                  required: true,
                  hint: null,
                  options: [],
                  title: {
                      body: <T textName='storeEmail' defaultStr='Email' page='/store' />
                  },
                  type: 'input',
                  value: userData?.email || userData?.contacts?.email
              },
              {
                  attribute: 'recipient_phone',
                  group: 'info',
                  subgroup: 'first',
                  required: true,
                  hint: null,
                  options: [],
                  placeholder: 'XXX-XX-XX',
                  title: {
                      body: <T textName='storePhone' defaultStr='Номер телефона' page='/store' />
                  },
                  type: 'phone-widget',
                  value: userData?.phone || userData?.contacts?.phone
              }
          ]
        : [
              {
                  attribute: 'second_name',
                  group: 'info',
                  subgroup: 'first',
                  disabled: true,
                  hint: null,
                  options: [],
                  title: {
                      body: <T textName='storeFamily' defaultStr='Фамилия' page='/store' />
                  },
                  type: 'input',
                  value: userData?.last_name
              },
              {
                  attribute: 'name',
                  group: 'info',
                  subgroup: 'first',
                  disabled: true,
                  hint: null,
                  options: [],
                  title: {
                      body: <T textName='storeName' defaultStr='Имя' page='/store' />
                  },
                  type: 'input',
                  maxLength: 10,
                  value: userData?.first_name
              },
              {
                  attribute: 'email',
                  group: 'info',
                  subgroup: 'first',
                  disabled: true,
                  hint: null,
                  options: [],
                  title: {
                      body: <T textName='storeEmail' defaultStr='Email' page='/store' />
                  },
                  type: 'input',
                  value: userData?.email || userData?.contacts?.email
              },
              {
                  attribute: 'phone',
                  group: 'info',
                  subgroup: 'first',
                  required: true,
                  hint: null,
                  options: [],
                  placeholder: 'XXX-XX-XX',
                  title: {
                      body: <T textName='storePhone' defaultStr='Номер телефона' page='/store' />
                  },
                  type: 'phone-widget',
                  value: userData?.phone || userData?.contacts?.phone
              }
          ];
    const tabs = [
        {
            alias: 'info',
            title: ''
        }
    ];
    tabs.reduce((accum, tab) => {
        accum[tab.alias] = {
            title: tab.title,
            fields: fields.filter((field) => field.group === tab.alias)
        };
        setFormsData(accum);
    }, {});
};

export const storeFormDataRec = {
    infoDelivery: {
        fields: [
            {
                attribute: 'recipient_second_name',
                default_value: null,
                disabled: false,
                group: 'info',
                subgroup: 'first',
                hint: null,
                options: [],
                required: true,
                title: {
                    body: <T textName='storeFamily' defaultStr='Фамилия' page='/store' />
                },
                type: 'input'
            },
            {
                attribute: 'recipient_name',
                default_value: null,
                disabled: false,
                group: 'info',
                subgroup: 'first',
                hint: null,
                options: [],
                required: true,
                title: {
                    body: <T textName='storeName' defaultStr='Имя' page='/store' />
                },
                type: 'input',
                maxLength: 10
            },
            {
                attribute: 'phone',
                default_value: null,
                disabled: false,
                group: 'info',
                subgroup: 'first',
                hint: null,
                options: [],
                placeholder: 'XXX-XX-XX',
                required: true,
                title: {
                    body: <T textName='storePhone' defaultStr='Номер телефона' page='/store' />
                },
                type: 'phone-widget'
            }
        ],
        title: ''
    }
};
export const storeFormDataDelivery = (storeFormData, translation, currierMethodsUrl, initValue, isCurrierMethodsEmpty) => {
    const warehouseFilters = ['country_id', 'region_id', 'city_id'];
    const warehouseFiltersFromData = ['delivery_country_id', 'delivery_state_id', 'delivery_city_id'];
    const warehouse_filter = warehouseFilters.reduce((acc, filter, idx) => {
        if (storeFormData[warehouseFiltersFromData[idx]]) {
            acc += `${acc.length ? '&' : '?'}filter[${filter}]=${storeFormData[warehouseFiltersFromData[idx]]['geoname_id']}`;
        }
        return acc;
    }, '');
    return {
        infoDelivery: {
            fields: [
                {
                    attribute: 'delivery_type',
                    type: 'radio-list',
                    // getOptions: {
                    //      url: `${API_SERVER_URL}/api/v1/shop/delivery-methods/${cartData?.id}`
                    // },
                    title: {
                        body: <T textName='storeDeliveryType' defaultStr='Выберите способ доставки' page='/store' />
                    },
                    options: isCurrierMethodsEmpty
                        ? [
                              {
                                  title: t('pickup', 'Самовывоз', '/store', translation),
                                  value: 'DHL'
                              }
                          ]
                        : [
                              {
                                  title: t('courier_service', 'Курьерская служба', '/store', translation),
                                  value: 'currier'
                              },
                              {
                                  title: t('pickup', 'Самовывоз', '/store', translation),
                                  value: 'DHL'
                              }
                          ],
                    value: storeFormData && storeFormData['delivery_type'] ? storeFormData['delivery_type'] : ''
                },
                ...(storeFormData && storeFormData['delivery_type']
                    ? [
                          {
                              attribute: 'delivery_country_id',
                              default_value: null,
                              disabled: true,
                              required: true,
                              group: 'delivery',
                              hint: null,
                              options: [],
                              title: {
                                  body: <T textName='storeCountry' defaultStr='Страна' page='/store' />
                              },
                              name: 'payment_type',
                              placeholder: t('storeChooseCountry', 'Выберите страну', '/store', translation),
                              type: 'location_widget',
                              value:
                                  storeFormData && storeFormData['delivery_country_id']
                                      ? storeFormData['delivery_country_id']
                                      : ''
                          },
                          {
                              attribute: 'delivery_state_id',
                              default_value: null,
                              notDisabled: true,
                              disabled: false,
                              group: 'delivery',
                              required: true,
                              hint: null,
                              options: [],
                              title: {
                                  body: <T textName='storeRegion' defaultStr='Область' page='/store' />
                              },
                              name: 'payment_type',
                              placeholder: t('storeChooseRegion', 'Выберите область', '/store', translation),
                              type: 'location_widget',
                              value: storeFormData && storeFormData['delivery_state_id'] ? storeFormData['delivery_state_id'] : ''
                          },
                          {
                              attribute: 'delivery_city_id',
                              default_value: null,
                              required: true,
                              disabled: false,
                              group: 'delivery',
                              hint: null,
                              options: [],
                              title: {
                                  body: <T textName='storeCity' defaultStr='Город' page='/store' />
                              },
                              name: 'payment_type',
                              placeholder: t('storeChooseCity', 'Выберите город', '/store', translation),
                              type: 'location_widget',
                              value: storeFormData && storeFormData['delivery_city_id'] ? storeFormData['delivery_city_id'] : '',
                              preparedLoad: false
                          },
                          ...(storeFormData['delivery_type'] === 'currier'
                              ? [
                                    {
                                        attribute: 'delivery_street',
                                        default_value: null,
                                        disabled: false,
                                        group: 'delivery',
                                        hint: null,
                                        options: [],
                                        placeholder: t('storeChooseStreet', 'Север-Куинн-стрит', '/store', translation),
                                        required: true,
                                        title: {
                                            body: <T textName='storeAddress' defaultStr='Адрес' page='/store' />
                                        },
                                        type: 'input'
                                    }
                                ]
                              : [{}])
                      ]
                    : []),
                ...(storeFormData && storeFormData['delivery_type'] === 'currier'
                    ? [
                          {
                              attribute: 'delivery_method_price_id',
                              type: 'select',
                              title: { body: t('courier_service', 'Курьерская служба', '/store', translation) },
                              getOptions: {
                                  url: currierMethodsUrl,
                                  sorter: (data) =>
                                      data?.map((method) => ({
                                          value: method?.user_price?.id,
                                          label: method?.name,
                                          user_price: method?.user_price
                                      })),
                                  disableCache: true,
                                  currency: initValue?.country_id?.currency
                              },
                              disabled: !storeFormData['delivery_city_id']?.['geoname_id'],
                              valueId:
                                  storeFormData && storeFormData['delivery_method_price_id']
                                      ? storeFormData['delivery_method_price_id']
                                      : null
                          }
                      ]
                    : storeFormData && storeFormData['delivery_type'] === 'DHL'
                    ? [
                          {
                              attribute: 'warehouse_id',
                              type: 'select',
                              getOptions: {
                                  url: `${API_SERVER_URL}/api/v1/warehouse/warehouses/for-shop${warehouse_filter}`,
                                  sorter: (data) => {
                                      return data?.map((warehouse) => ({
                                          ...warehouse,
                                          title: warehouse?.address
                                              ? `${warehouse?.name || ''} (${t('address', 'Адрес', 'all', translation)}: ${
                                                    warehouse?.address
                                                })`
                                              : warehouse?.name || ''
                                      }));
                                  },
                                  preparedLoad: true
                              },
                              required: true,
                              title: { body: t('stock', 'Склад', 'all', translation) },
                              valueId: storeFormData && storeFormData['warehouse_id'] ? storeFormData['warehouse_id']?.id : null
                          }
                      ]
                    : [])
                // {
                //     attribute: 'delivery_postcode',
                //     default_value: null,
                //     disabled: false,
                //     group: 'delivery',
                //     hint: null,
                //     options: [],
                //     placeholder: '20001',
                //     required: true,
                //     title: {
                //         body: <T textName='storeStreet' defaultStr='Индекс' page='/store' />
                //     },
                //     type: 'input'
                // },
                // {
                //     attribute: 'delivery_house',
                //     default_value: null,
                //     disabled: false,
                //     group: 'delivery',
                //     hint: null,
                //     options: [],
                //     placeholder: '123',
                //     required: true,
                //     title: {
                //         body: <T textName='storeHouse' defaultStr='Дом' page='/store' />
                //     },
                //     type: 'input'
                // },
                // {
                //     attribute: 'delivery_block',
                //     default_value: null,
                //     disabled: false,
                //     group: 'delivery',
                //     hint: null,
                //     options: [],
                //     placeholder: '1',
                //     required: false,
                //     title: {
                //         body: <T textName='storeCorpuse' defaultStr='Корпус/Подъезд' page='/store' />
                //     },
                //     type: 'input'
                // },
                // {
                //     attribute: 'delivery_flat',
                //     default_value: null,
                //     disabled: false,
                //     group: 'delivery',
                //     hint: null,
                //     options: [],
                //     placeholder: '5',
                //     required: false,
                //     title: {
                //         body: <T textName='storeFlat' defaultStr='Квартира' page='/store' />
                //     },
                //     type: 'input'
                // }
            ],
            title: ''
        }
    };
};

export const getFormStyles = (css) => ({
    second_name: { wrapper: css.formControl__W100 },
    name: { wrapper: css.formControl__W100 },
    phone: { wrapper: classNames(css.formControl__W100, css.formControl_phone) },
    email: { wrapper: css.formControl__W100 },
    recipient_second_name: { wrapper: css.formControl__W100 },
    recipient_name: { wrapper: css.formControl__W100 },
    recipient_phone: { wrapper: css.formControl__W100 },
    delivery_type: { wrapper: css.deliveryTypeWrapper, radio: css.deliveryTypeRadio, itemWrapper: css.deliveryTypeRadioWrapper },
    delivery_country_id: { wrapper: css.formControl__W100 },
    delivery_state_id: { wrapper: css.formControl__W100 },
    delivery_city_id: { wrapper: css.formControl__W100 },
    delivery_street: { wrapper: css.formControl__W100 },
    warehouse_id: { wrapper: classNames(css.formControl__W100, css.mb0) },
    delivery_postcode: { wrapper: css.formControl__WF167 },
    delivery_house: { wrapper: css.formControl__WF167 },
    delivery_block: { wrapper: css.formControl__WF167 },
    delivery_flat: { wrapper: css.formControl__WF167 },
    delivery_house: { wrapper: css.formControl__W100 },
    delivery_method_price_id: { wrapper: classNames(css.formControl__W100, css.mb0) },
    comment: {},
    do_not_call_back: { wrapper: css.do_not_call_backWrapper }
});

export const pageSettings = { buttons: false };

export const options = {
    statusUser: [
        {
            id: 1,
            value: 1,
            title: <T textName='newBuyerStoreOptions' defaultStr='Я новый покупатель' page='/store' />
        },
        {
            id: 2,
            value: 2,
            title: <T textName='defaultBuyerStoreOptions' defaultStr='Я постоянный покупатель' page='/store' />
        }
    ]
};

export const cartForm = [
    // {
    //     id: 2,
    //     title: <T textName='initCartFormTitle2' defaultStr='Ваш заказ' page='/store' />,
    //     group: 'order',
    //     field: ['items']
    // },
    {
        id: 1,
        title: <T textName='initCartFormTitle1-v1' defaultStr='Личные данные' page='/store' />,
        group: 'contacts',
        field: ['name', 'surname', 'email', 'phone', 'recipient_phone', 'recipient_name', 'recipient_second_name']
    },
    {
        id: 3,
        title: <T textName='initCartFormTitle3-v1' defaultStr='Способ доставки' page='/store' />,
        group: 'delivery',
        field: [
            'delivery_country_id',
            'delivery_delivery_city_id',
            'delivery_delivery_street',
            'delivery_postcode',
            'delivery_delivery_house'
        ]
    },
    {
        id: 4,
        title: <T textName='initCartFormTitle4-v1' defaultStr='Способ оплаты' page='/store' />,
        group: 'payment',
        field: ['police_agree', 'payment_type', 'finance_account_id', 'payments']
    }
];
